var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        "cancel-variant": "outline-secondary",
        centered: "",
        "ok-title": "적용",
        "cancel-title": "취소",
        size: "lg",
        title: "관심 컨텐츠 유형 선택",
        "no-close-on-esc": "",
        "no-close-on-backdrop": "",
      },
      on: {
        ok: function ($event) {
          $event.preventDefault()
          return _vm.submit()
        },
        close: function ($event) {
          $event.preventDefault()
          return _vm.close()
        },
        cancel: function ($event) {
          $event.preventDefault()
          return _vm.close()
        },
      },
      model: {
        value: _vm.showInterestContentSelect,
        callback: function ($$v) {
          _vm.showInterestContentSelect = $$v
        },
        expression: "showInterestContentSelect",
      },
    },
    [
      _c(
        "b-row",
        { staticClass: "mt-1" },
        [
          _c("b-table", {
            ref: "refInterestContentTable",
            staticClass: "position-relative",
            attrs: {
              "primary-key": "id",
              items: _vm.fetchData,
              fields: _vm.selectTableColumns,
              "sort-by": _vm.sortBy,
              "sort-desc": _vm.isSortDesc,
              responsive: "",
              "sticky-header": "",
            },
            on: {
              "update:sortBy": function ($event) {
                _vm.sortBy = $event
              },
              "update:sort-by": function ($event) {
                _vm.sortBy = $event
              },
              "update:sortDesc": function ($event) {
                _vm.isSortDesc = $event
              },
              "update:sort-desc": function ($event) {
                _vm.isSortDesc = $event
              },
            },
            scopedSlots: _vm._u([
              {
                key: "cell(select)",
                fn: function (data) {
                  return [
                    _c(
                      "div",
                      { staticStyle: { "text-align": "center" } },
                      [
                        _c("b-form-checkbox", {
                          attrs: {
                            id: "content-checkbox-" + data.item.id,
                            value: data.item,
                            name: "content-checkbox",
                          },
                          model: {
                            value: _vm.selectedContent,
                            callback: function ($$v) {
                              _vm.selectedContent = $$v
                            },
                            expression: "selectedContent",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
              },
              {
                key: "cell(title)",
                fn: function (data) {
                  return [
                    _c(
                      "label",
                      {
                        staticClass: "content-label",
                        attrs: { for: "content-checkbox-" + data.item.id },
                      },
                      [
                        _c("div", [_vm._v(_vm._s(data.item.title))]),
                        _c("small", [_vm._v(_vm._s(data.item.description))]),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }